/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventTypeEnum } from './EventTypeEnum';
import {
    EventTypeEnumFromJSON,
    EventTypeEnumFromJSONTyped,
    EventTypeEnumToJSON,
    EventTypeEnumToJSONTyped,
} from './EventTypeEnum';

/**
 * 
 * @export
 * @interface EventUpdate
 */
export interface EventUpdate {
    /**
     * 
     * @type {EventTypeEnum}
     * @memberof EventUpdate
     */
    eventType?: EventTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof EventUpdate
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventUpdate
     */
    eventDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EventUpdate
     */
    sourceUrl?: string | null;
}



/**
 * Check if a given object implements the EventUpdate interface.
 */
export function instanceOfEventUpdate(value: object): value is EventUpdate {
    return true;
}

export function EventUpdateFromJSON(json: any): EventUpdate {
    return EventUpdateFromJSONTyped(json, false);
}

export function EventUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': json['event_type'] == null ? undefined : EventTypeEnumFromJSON(json['event_type']),
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'eventDate': json['event_date'] == null ? undefined : (new Date(json['event_date'])),
        'sourceUrl': json['source_url'] == null ? undefined : json['source_url'],
    };
}

export function EventUpdateToJSON(json: any): EventUpdate {
    return EventUpdateToJSONTyped(json, false);
}

export function EventUpdateToJSONTyped(value?: EventUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_type': EventTypeEnumToJSON(value['eventType']),
        'title': value['title'],
        'description': value['description'],
        'event_date': value['eventDate'] == null ? undefined : ((value['eventDate'] as any).toISOString().substring(0,10)),
        'source_url': value['sourceUrl'],
    };
}

